import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { isIOS, deviceType, osVersion } from 'react-device-detect';

import Quagga from 'quagga';
import { Html5Qrcode } from 'html5-qrcode';

import { deviceDetect } from 'react-device-detect';

import { history } from '../../../store';

import isLoggedIn from '../../../utils/auth';

import scrollToComponent from 'react-scroll-to-component';

import RhinoModal from '../../common/modal/RhinoModal';

import * as jewelryActionCreators from '../../../actions/jewelry';
let allActionCreators = Object.assign({}, jewelryActionCreators);


class JewelrySearch extends React.Component {

	constructor(props) {
		
    super(props);

    const PRICE_MIN = 0;
    const PRICE_MAX = 1000000;
    const COST_MIN = 0;
    const COST_MAX = 1000000;
    const CARAT_MIN = 0;
    const CARAT_MAX = 20;

    this.scanningElementId = 'scanning-element-jewelry-search-id';

    this.state = {

      searchTerm: this.props.jewelry.jewelryFilter.search_term ? this.props.jewelry.jewelryFilter.search_term : '',

      jewelryType: this.props.jewelry.jewelryFilter.jewelryType && this.props.jewelry.jewelryFilter.jewelryType.length > 0 ? this.props.jewelry.jewelryFilter.jewelryType.split(',') : ['All'],
      gemstoneType: this.props.jewelry.jewelryFilter.gemstoneType && this.props.jewelry.jewelryFilter.gemstoneType.length > 0 ? this.props.jewelry.jewelryFilter.gemstoneType.split(',') : ['All'],
      style: this.props.jewelry.jewelryFilter.style && this.props.jewelry.jewelryFilter.style.length > 0 ? this.props.jewelry.jewelryFilter.style.split(',') : ['All'],
      designers: this.props.jewelry.jewelryFilter.designers && this.props.jewelry.jewelryFilter.designers.length > 0 ? this.props.jewelry.jewelryFilter.designers.split(',') : ['All'],

      priceMin: this.props.jewelry.jewelryFilter.price_min && this.props.jewelry.jewelryFilter.price_min != PRICE_MIN ? this.props.jewelry.jewelryFilter.price_min : '',
      priceMax: this.props.jewelry.jewelryFilter.price_max && this.props.jewelry.jewelryFilter.price_max != PRICE_MAX ? this.props.jewelry.jewelryFilter.price_max : '',
      costMin: this.props.jewelry.jewelryFilter.cost_min && this.props.jewelry.jewelryFilter.cost_min != COST_MIN ? this.props.jewelry.jewelryFilter.cost_min : '',
      costMax: this.props.jewelry.jewelryFilter.cost_max && this.props.jewelry.jewelryFilter.cost_max != COST_MAX ? this.props.jewelry.jewelryFilter.cost_max : '',

      diamondMin: this.props.jewelry.jewelryFilter.diamond_min && this.props.jewelry.jewelryFilter.diamond_min != CARAT_MIN ? this.props.jewelry.jewelryFilter.diamond_min : '',
      diamondMax: this.props.jewelry.jewelryFilter.diamond_max && this.props.jewelry.jewelryFilter.diamond_max != CARAT_MAX ? this.props.jewelry.jewelryFilter.diamond_max : '',
      gemstoneMin: this.props.jewelry.jewelryFilter.gemstone_min && this.props.jewelry.jewelryFilter.gemstone_min != CARAT_MIN ? this.props.jewelry.jewelryFilter.gemstone_min : '',
      gemstoneMax: this.props.jewelry.jewelryFilter.gemstone_max && this.props.jewelry.jewelryFilter.gemstone_max != CARAT_MAX ? this.props.jewelry.jewelryFilter.gemstone_max : '',

      priceMinDefault: PRICE_MIN,
      priceMaxDefault: PRICE_MAX,
      costMinDefault: COST_MIN,
      costMaxDefault: COST_MAX,
      diamondMinDefault: CARAT_MIN,
      diamondMaxDefault: CARAT_MAX,
      gemstoneMinDefault: CARAT_MIN,
      gemstoneMaxDefault: CARAT_MAX,

      scanningModelOpen: false,
      scanningError: null,
      scanningAutomatedMode: null,

      manualSku: '',
    }

    this.scanningElement = null;
    this.scanningElementRef = React.createRef();

    this.scanSuccessMtd = this.scanSuccess.bind(this);
    this.scanErrorMtd = this.scanError.bind(this);
	}

  componentDidMount() {
    // Nothing now
  }

  componentWillUnmount() {
    this.terminateScanner();
  }

  async initiateScanner() {
    if(this.scanningElementRef && this.scanningElementRef.current) {

      // Pick the right camera
      const constraints = {
        audio: false,
        video: {
          facingMode: 'environment',
          width: { ideal: 4096 },
          height: { ideal: 2160 },
        }
      }

      const cams = await navigator.mediaDevices.getUserMedia(constraints);

      const allCams = cams.getVideoTracks();

      let camId = '';
      let camMaxWidth = 0;

      for(const trk of allCams) {
        
        const capabilities = trk.getCapabilities();
        const settings = trk.getSettings();

        if(capabilities.width.max > camMaxWidth) {
          camId = settings.deviceId;
          camMaxWidth = capabilities.width.max;
        }
      }


      const qConstraints = camId ? { deviceId: camId } : { facingMode: 'environment' };

      Quagga.onDetected(this.scanSuccessMtd);
      // Quagga.onProcessed(this.scanSuccessMtd)

      Quagga.init({
        locate: true,
        frequency: 10,
        inputStream: {
          name : "Live",
          type : "LiveStream",
          target: document.querySelector(`#${this.scanningElementId}`),
          constraints: qConstraints,
        },
        decoder : {
          readers : ["code_128_reader"],
          multiple: false,
        },
        locator: {
          halfSample: false,
          patchSize: "small",
        },
        debug: false,
      }, function(err) {
          if (err) {
              console.error(err);
              return
          }
          Quagga.start();
      });
    }
  }

  terminateScanner() {
    try {
      Quagga.offDetected(this.scanSuccessMtd);
      Quagga.stop();
    } catch(err) {
      console.error(err);
    }
  }

  scanSuccess(data) {

    // this.userNav(`jewelry/view/MTGPL04404`);
    this.userNav(`jewelry/barcode/${data.codeResult.code}`);

    this.closeScanningModal();
  }

  scanError(err) {
    console.error(err);
  }

  userNav(page) {
    history.push('/' + page);
  }

  closeScanningModal() {
    this.setState({ scanningModelOpen: false }, () => {
      this.terminateScanner();
    });
  }

  defaultToAutomated() {
    try {
      
      const minIos = 16;
      const minAndroid = 13;

      const deviceObj = deviceDetect();

      const versionInt = parseInt(deviceObj.osVersion.split('.')[0]);

      // if(deviceObj.os === 'iOS' && versionInt >= minIos) {
      //   return true;
      // } else if(deviceObj.os === 'Android' && versionInt >= minAndroid) {
      //   return true;
      // }
      return false;

    } catch(err) {
      return false;
    }
  }

  setInputToAutomated(isAutomated) {
    this.setState({
      scanningAutomatedMode: isAutomated,
    }, () => {
      if(isAutomated) {
        this.initiateScanner();
      } else {
        this.terminateScanner();
      }
    });
  }

  openScanningModal() {
    this.setState({ scanningModelOpen: true }, () => {
      this.setInputToAutomated(this.state.scanningAutomatedMode === null ? this.defaultToAutomated() : this.state.scanningAutomatedMode);
    });
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  setJewelryType(jewelryType) {
    if(jewelryType === 'All') {
      this.setState({ jewelryType: ['All'] });
      return;
    }
    if(this.state.jewelryType.indexOf('All') > -1) {
      this.setState({ jewelryType: [ jewelryType ] });
      return;
    }

    let clone = this.cloneArray(this.state.jewelryType);
    let i = this.state.jewelryType.indexOf(jewelryType);
    if(i === -1) {
      clone.push(jewelryType);
      this.setState({ jewelryType: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ jewelryType: ['All'] });
      } else {
        this.setState({ jewelryType: clone });
      }
    }
  }

  setGemstoneType(gemstoneType) {
    if(gemstoneType === 'All') {
      this.setState({ gemstoneType: ['All'] });
      return;
    }
    if(this.state.gemstoneType.indexOf('All') > -1) {
      this.setState({ gemstoneType: [ gemstoneType ] });
      return;
    }

    let clone = this.cloneArray(this.state.gemstoneType);
    let i = this.state.gemstoneType.indexOf(gemstoneType);
    if(i === -1) {
      clone.push(gemstoneType);
      this.setState({ gemstoneType: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ gemstoneType: ['All'] });
      } else {
        this.setState({ gemstoneType: clone });
      }
    }
  }

  setStyle(style) {
    if(style === 'All') {
      this.setState({ style: ['All'] });
      return;
    }
    if(this.state.style.indexOf('All') > -1) {
      this.setState({ style: [ style ] });
      return;
    }

    let clone = this.cloneArray(this.state.style);
    let i = this.state.style.indexOf(style);
    if(i === -1) {
      clone.push(style);
      this.setState({ style: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ style: ['All'] });
      } else {
        this.setState({ style: clone });
      }
    }
  }

  setDesigner(designers) {
    if(designers === 'All') {
      this.setState({ designers: ['All'] });
      return;
    }
    if(this.state.designers.indexOf('All') > -1) {
      this.setState({ designers: [ designers ] });
      return;
    }

    let clone = this.cloneArray(this.state.designers);
    let i = this.state.designers.indexOf(designers);
    if(i === -1) {
      clone.push(designers);
      this.setState({ designers: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ designers: ['All'] });
      } else {
        this.setState({ designers: clone });
      }
    }
  }

  changeSearchTerm(evt) {
    this.setState({ searchTerm: evt.target.value });
  }

  changePriceMin(evt) {
    this.setState({ priceMin: evt.target.value });
  }

  changePriceMax(evt) {
    this.setState({ priceMax: evt.target.value });
  }

  validatePriceMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.priceMax === '' ? '' : parseInt(this.state.priceMax);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  validatePriceMax(evt) {
    let minValue = this.state.priceMin === '' ? '' : parseInt(this.state.priceMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  changeCostMin(evt) {
    this.setState({ costMin: evt.target.value });
  }

  changeCostMax(evt) {
    this.setState({ costMax: evt.target.value });
  }

  validateCostMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.costMax === '' ? '' : parseInt(this.state.costMax);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  validateCostMax(evt) {
    let minValue = this.state.costMin === '' ? '' : parseFloat(this.state.costMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  changeDiamondMin(evt) {
    this.setState({ diamondMin: evt.target.value });
  }

  changeDiamondMax(evt) {
    this.setState({ diamondMax: evt.target.value });
  }

  validateDiamondMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.diamondMax === '' ? '' : parseInt(this.state.diamondMax);

    if(isNaN(minValue)) { minValue = this.state.diamondMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.diamondMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 20) {
      minValue = 20;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      diamondMin: minValue,
      diamondMax: maxValue,
    });
  }

  validateDiamondMax(evt) {
    let minValue = this.state.diamondMin === '' ? '' : parseFloat(this.state.diamondMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.diamondMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.diamondMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 20) {
      maxValue = 20;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      diamondMin: minValue,
      diamondMax: maxValue,
    });
  }

  changeGemstoneMin(evt) {
    this.setState({ gemstoneMin: evt.target.value });
  }

  changeGemstoneMax(evt) {
    this.setState({ gemstoneMax: evt.target.value });
  }

  validateGemstoneMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.gemstoneMax === '' ? '' : parseInt(this.state.gemstoneMax);

    if(isNaN(minValue)) { minValue = this.state.gemstoneMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.gemstoneMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 20) {
      minValue = 20;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      gemstoneMin: minValue,
      gemstoneMax: maxValue,
    });
  }

  validateGemstoneMax(evt) {
    let minValue = this.state.gemstoneMin === '' ? '' : parseFloat(this.state.gemstoneMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.gemstoneMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.gemstoneMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 20) {
      maxValue = 20;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      gemstoneMin: minValue,
      gemstoneMax: maxValue,
    });
  }

  scrollToAdvanced() {
    scrollToComponent(this.priceBlock, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollToTop() {
    scrollToComponent(this.diamondMainBody, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'linear',
    });
  }

  createList(optionsArray) {

    let first = true;
    let optionList = '';

    if(optionsArray.length === 0) {
      return 'All';
    }

    for(let i = 0; i < optionsArray.length; i++) {
      if(first) {
        optionList = optionsArray[i];
      } else {
        optionList += ',' + optionsArray[i];
      }
      first = false;
    }
    return optionList;
  }

  resetSearch(evt) {

    evt.stopPropagation();

    this.setState({
      
      jewelryType: ['All'],
      designers: ['All'],

      searchTerm: '',

      priceMin: '',
      priceMax: '',
      costMin: '',
      costMax: '',
    }, () => {
      this.scrollToTop();
    })
  }

  handleSubmit() {

    const jewelryFilter = {

      price_min: this.state.priceMin === '' ? this.state.priceMinDefault : this.state.priceMin,
      price_max: this.state.priceMax === '' ? this.state.priceMaxDefault : this.state.priceMax,
      cost_min: this.state.costMin === '' ? this.state.costMinDefault : this.state.costMin,
      cost_max: this.state.costMax === '' ? this.state.costMaxDefault : this.state.costMax,
      diamond_min: this.state.diamondMin === '' ? this.state.diamondMinDefault : this.state.diamondMin,
      diamond_max: this.state.diamondMax === '' ? this.state.diamondMaxDefault : this.state.diamondMax,
      gemstone_min: this.state.gemstoneMin === '' ? this.state.gemstoneMinDefault : this.state.gemstoneMin,
      gemstone_max: this.state.gemstoneMax === '' ? this.state.gemstoneMaxDefault : this.state.gemstoneMax,

      jewelryType: this.createList(this.state.jewelryType),
      gemstoneType: this.createList(this.state.gemstoneType),
      style: this.createList(this.state.style),

      page: 1,
    }

    if(this.state.searchTerm) {
      jewelryFilter['search_term'] = this.state.searchTerm;
    }

    this.props.setJewelryFilters(jewelryFilter);
    history.push('jewelry/results');
  }

  changeManualSku(evt) {
    this.setState({ manualSku: evt.target.value });
  }

  submitManualSearch() {
    if(this.state.manualSku) {
      this.userNav(`jewelry/view/${this.state.manualSku}`);
    }
  }

	render() {

		return <div className='JewelrySearch' ref={(div) => { this.diamondMainBody = div; }}>
			<div className={isLoggedIn() ? 'searchHeader loggedIn' : 'searchHeader'}>
        <div className='searchLabel' style={{ marginBottom: '15px'}}>Find the Perfect Piece</div>
        <div className='searchInput'>
          <input 
            type='text'
            placeholder='Search by SKU'
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm.bind(this)} />
          <div className='searchIcon' onClick={this.handleSubmit.bind(this)}>
            <img src='/img/diamonds/magnify.svg' />
          </div>
        </div>
      </div>
      <div className='filterSection'>

        <div className='scanSectionWrapper'>
          <div className='scanTitle' style={{ display: 'none' }}>Jewelry Lookup Scanner</div>
          <div className='scanSection' onClick={this.openScanningModal.bind(this)}>
            <div className='iconWrapper'>
              <div className='iconElement'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>
              </div>
            </div>
            <div className='iconLabel'>
              <div className='labelLiner'>Scan Barcode</div>
            </div>
          </div>
        </div>
        
        <div className='locationsBlock'>
          <div className='blockTitle'>Jewelry Type</div>
          <div className={'radioGroup locationRadio'}>
            <div 
              className={this.state.jewelryType.includes('necklace') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('necklace')}>
              <div className='radioLabel'>Necklace</div>
            </div>
            <div 
              className={this.state.jewelryType.includes(`earrings`) ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('earrings')}>
              <div className='radioLabel'>Earrings</div>
            </div>
            <div 
              className={this.state.jewelryType.includes('bracelet') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('bracelet')}>
              <div className='radioLabel'>Bracelet</div>
            </div>
            <div 
              className={this.state.jewelryType.includes('ring') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('ring')}>
              <div className='radioLabel'>Ring</div>
            </div>
            <div 
              className={this.state.jewelryType.includes('studs') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('studs')}>
              <div className='radioLabel'>Classic Stud</div>
            </div>
            <div 
              className={this.state.jewelryType.includes('pendant') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('pendant')}>
              <div className='radioLabel'>Classic Pendant</div>
            </div>
            <div 
              className={this.state.jewelryType.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setJewelryType('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='locationsBlock' style={{ display: 'none' }}>
          <div className='blockTitle'>Gemstone Type</div>
          <div className={'radioGroup locationRadio'}>
            <div 
              className={this.state.gemstoneType.includes('alexandrite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('alexandrite')}>
              <div className='radioLabel'>Alexandrite</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('amethyst') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('amethyst')}>
              <div className='radioLabel'>Amethyst</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('aqua') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('aqua')}>
              <div className='radioLabel'>Aqua</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('blue-topaz') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('blue-topaz')}>
              <div className='radioLabel'>Blue Topaz</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('citrine') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('citrine')}>
              <div className='radioLabel'>Citrine</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('diamond') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('diamond')}>
              <div className='radioLabel'>Diamond</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('emerald') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('emerald')}>
              <div className='radioLabel'>Emerald</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('garnet') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('garnet')}>
              <div className='radioLabel'>Garnet</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('lapis') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('lapis')}>
              <div className='radioLabel'>Lapis</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('malachite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('malachite')}>
              <div className='radioLabel'>Malachite</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('morganite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('morganite')}>
              <div className='radioLabel'>Morganite</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('onyx') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('onyx')}>
              <div className='radioLabel'>Onyx</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('opal') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('opal')}>
              <div className='radioLabel'>Opal</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('pearl') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('pearl')}>
              <div className='radioLabel'>Pearl</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('peridot') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('peridot')}>
              <div className='radioLabel'>Peridot</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('prasiolite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('prasiolite')}>
              <div className='radioLabel'>Prasiolite</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('ruby') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('ruby')}>
              <div className='radioLabel'>Ruby</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('sapphire') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('sapphire')}>
              <div className='radioLabel'>Sapphire</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('tanzanite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('tanzanite')}>
              <div className='radioLabel'>Tanzanite</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('tourmaline') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('tourmaline')}>
              <div className='radioLabel'>Tourmaline</div>
            </div>
            <div 
              className={this.state.gemstoneType.includes('turquoise') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('turquoise')}>
              <div className='radioLabel'>Turquoise</div>
            </div>
            <div 
              className={this.state.gemstoneType.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setGemstoneType('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='locationsBlock'>
          <div className='blockTitle'>Designers</div>
          <div className={'radioGroup locationRadio'}>
            <div 
              className={this.state.designers.includes('ajaffe') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('ajaffe')}>
              <div className='radioLabel'>A. Jaffe</div>
            </div>
            <div 
              className={this.state.designers.includes('amden') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('amden')}>
              <div className='radioLabel'>Amden</div>
            </div>
            <div 
              className={this.state.designers.includes('artcarved') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('artcarved')}>
              <div className='radioLabel'>Artcarved</div>
            </div>
            <div 
              className={this.state.designers.includes('benchmark') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('benchmark')}>
              <div className='radioLabel'>Benchmark</div>
            </div>
            <div 
              className={this.state.designers.includes('cgonshor') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('cgonshor')}>
              <div className='radioLabel'>C Gonshor</div>
            </div>
            <div 
              className={this.state.designers.includes('christianbauer') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('christianbauer')}>
              <div className='radioLabel'>Christian Bauer</div>
            </div>
            <div 
              className={this.state.designers.includes('christopherdesigns') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('christopherdesigns')}>
              <div className='radioLabel'>Christopher Designs</div>
            </div>
            <div 
              className={this.state.designers.includes('classique') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('classique')}>
              <div className='radioLabel'>Classique</div>
            </div>
            <div 
              className={this.state.designers.includes('coast') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('coast')}>
              <div className='radioLabel'>Coast</div>
            </div>
            <div 
              className={this.state.designers.includes('dddesigns') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('dddesigns')}>
              <div className='radioLabel'>Diamonds Direct Designs</div>
            </div>
            <div 
              className={this.state.designers.includes('diana') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('diana')}>
              <div className='radioLabel'>Diana</div>
            </div>
            <div 
              className={this.state.designers.includes('fana') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('fana')}>
              <div className='radioLabel'>Fana</div>
            </div>
            <div 
              className={this.state.designers.includes('furrerjacot') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('furrerjacot')}>
              <div className='radioLabel'>Furrer Jacot</div>
            </div>
            <div 
              className={this.state.designers.includes('gabrielco') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('gabrielco')}>
              <div className='radioLabel'>Gabriel & Co</div>
            </div>
            <div 
              className={this.state.designers.includes('goldman') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('goldman')}>
              <div className='radioLabel'>Goldman</div>
            </div>
            <div 
              className={this.state.designers.includes('henridaussi') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('henridaussi')}>
              <div className='radioLabel'>Henri Daussi</div>
            </div>
            <div 
              className={this.state.designers.includes('kirkkara') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('kirkkara')}>
              <div className='radioLabel'>Kirk Kara</div>
            </div>
            <div 
              className={this.state.designers.includes('kcdesigns') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('kcdesigns')}>
              <div className='radioLabel'>KC Designs</div>
            </div>
            <div 
              className={this.state.designers.includes('mastoloni') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('mastoloni')}>
              <div className='radioLabel'>Mastoloni</div>
            </div>
            <div 
              className={this.state.designers.includes('michaelm') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('michaelm')}>
              <div className='radioLabel'>Michael M</div>
            </div>
            <div 
              className={this.state.designers.includes('novel') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('novel')}>
              <div className='radioLabel'>Novel</div>
            </div>
            <div 
              className={this.state.designers.includes('odelia') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('odelia')}>
              <div className='radioLabel'>Odelia</div>
            </div>
            <div 
              className={this.state.designers.includes('pejay') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('pejay')}>
              <div className='radioLabel'>Pejay</div>
            </div>
            <div 
              className={this.state.designers.includes('ses') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('ses')}>
              <div className='radioLabel'>SES</div>
            </div>
            <div 
              className={this.state.designers.includes('simong') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('simong')}>
              <div className='radioLabel'>Simon G</div>
            </div>
            <div 
              className={this.state.designers.includes('sylvie') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('sylvie')}>
              <div className='radioLabel'>Sylvie</div>
            </div>
            <div 
              className={this.state.designers.includes('tacori') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('tacori')}>
              <div className='radioLabel'>Tacori</div>
            </div>
            <div 
              className={this.state.designers.includes('trueromanace') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('trueromanace')}>
              <div className='radioLabel'>True Romanace</div>
            </div>
            <div 
              className={this.state.designers.includes('uneek') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('uneek')}>
              <div className='radioLabel'>Uneek</div>
            </div>
            <div 
              className={this.state.designers.includes('verragio') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('verragio')}>
              <div className='radioLabel'>Verragio</div>
            </div>
            <div 
              className={this.state.designers.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setDesigner('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        

        <div className='locationsBlock' style={{ display: 'none' }}>
          <div className='blockTitle'>Style</div>
          <div className={'radioGroup locationRadio'}>
            <div 
              className={this.state.style.includes('vintage') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setStyle('vintage')}>
              <div className='radioLabel'>Vintage</div>
            </div>
            <div 
              className={this.state.style.includes('classic') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setStyle('classic')}>
              <div className='radioLabel'>Classic</div>
            </div>
            <div 
              className={this.state.style.includes('contemporary') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setStyle('contemporary')}>
              <div className='radioLabel'>Contemporary</div>
            </div>
            <div 
              className={this.state.style.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setStyle('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        

        <div className='priceBlock' ref={(div) => { this.priceBlock = div; }}>
          <div className='blockTitle'>Price</div>
          <div className='rangeWrapper'>
            <div className='rangeInput'>
              <input 
                className='rangeElement'
                placeholder='0'
                type='number'
                value={this.state.priceMin}
                onChange={this.changePriceMin.bind(this)}
                onBlur={this.validatePriceMin.bind(this)}
                min={0}
                max={this.state.priceMax}
                step={1} />
            </div>
            <div className='rangeTo'>to</div>
            <div className='rangeInput'>
              <input 
                className='rangeElement' 
                placeholder='1,000,000'
                type='number'
                value={this.state.priceMax}
                onChange={this.changePriceMax.bind(this)}
                onBlur={this.validatePriceMax.bind(this)}
                min={this.state.priceMin}
                max={1000000}
                step={1} />
            </div>
          </div>
        </div>
        {isLoggedIn() ?
          <div className='costBlock' ref={(div) => { this.costBlock = div; }} style={{ display: 'none' }}>
            <div className='blockTitle'>Cost</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0'
                  type='number'
                  value={this.state.costMin}
                  onChange={this.changeCostMin.bind(this)}
                  onBlur={this.validateCostMin.bind(this)}
                  min={0}
                  max={this.state.costMax}
                  step={1} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='1,000,000'
                  type='number'
                  value={this.state.costMax}
                  onChange={this.changeCostMax.bind(this)}
                  onBlur={this.validateCostMax.bind(this)}
                  min={this.state.costMin}
                  max={1000000}
                  step={1} />
              </div>
            </div>
          </div> :
          null
        }
      </div>

      <div className='priceBlock' style={{ display: 'none' }}>
        <div className='blockTitle'>Total Diamond Carat Weight</div>
        <div className='rangeWrapper'>
          <div className='rangeInput'>
            <input 
              className='rangeElement'
              placeholder='0'
              type='number'
              value={this.state.diamondMin}
              onChange={this.changeDiamondMin.bind(this)}
              onBlur={this.validateDiamondMin.bind(this)}
              min={0}
              max={this.state.diamondMax}
              step={0.01} />
          </div>
          <div className='rangeTo'>to</div>
          <div className='rangeInput'>
            <input 
              className='rangeElement' 
              placeholder='20'
              type='number'
              value={this.state.diamondMax}
              onChange={this.changeDiamondMax.bind(this)}
              onBlur={this.validateDiamondMax.bind(this)}
              min={this.state.diamondMin}
              max={20}
              step={0.01} />
          </div>
        </div>
      </div>

      <div className='priceBlock' style={{ display: 'none' }}>
        <div className='blockTitle'>Total Gemstone Carat Weight</div>
        <div className='rangeWrapper'>
          <div className='rangeInput'>
            <input 
              className='rangeElement'
              placeholder='0'
              type='number'
              value={this.state.gemstoneMin}
              onChange={this.changeGemstoneMin.bind(this)}
              onBlur={this.validateGemstoneMin.bind(this)}
              min={0}
              max={this.state.gemstoneMax}
              step={0.01} />
          </div>
          <div className='rangeTo'>to</div>
          <div className='rangeInput'>
            <input 
              className='rangeElement' 
              placeholder='20'
              type='number'
              value={this.state.gemstoneMax}
              onChange={this.changeGemstoneMax.bind(this)}
              onBlur={this.validateGemstoneMax.bind(this)}
              min={this.state.gemstoneMin}
              max={20}
              step={0.01} />
          </div>
        </div>
      </div>

      <div className={'searchSubmit bottomAction refreshIcon'} onClick={this.handleSubmit.bind(this)} style={{ marginTop: '30px' }}>
        Search
        <div className='iconWrapper' onClick={this.resetSearch.bind(this)}>
          <img src='/img/icons/reset.svg' />
        </div>
      </div>
      <div className='bottomActionSpacer'></div>
      
      <RhinoModal
        open={this.state.scanningModelOpen}>
        <div className='scanningModal'>
          <div className='closeModal' onClick={this.closeScanningModal.bind(this)}>&times;</div>
          <div className='scanningModalTitle'>{this.state.scanningAutomatedMode ? 'Scan Barcode' : 'Enter SKU'}</div>
          <div className='scanningModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' alt='' />
          </div>
          {this.state.scanningError ? 
            <div className='errMessage'>{this.state.scanningError}</div> :
            null
          }
          <div className='scanningBody'>
            {this.state.scanningAutomatedMode ?
              <div className='scanningElementWrapper'>
                <div id={this.scanningElementId} ref={this.scanningElementRef} className='scanningElement'></div>
              </div> :
              <div className='manualEntryWrapper'>
                <form className='manualEntryForm' onSubmit={this.submitManualSearch.bind(this)}>
                  <div className='mfInputWrapper'>
                    <input
                      className='mfInput'
                      value={this.state.manualSku}
                      onChange={this.changeManualSku.bind(this)}
                      placeholder={'BR11001563'} />
                  </div>
                  <div className='mfSubmitWrapper'>
                    <button type='submit' className='mfSubmitButton'>Submit</button>
                  </div>
                </form>
              </div>
            }
            <div className='automationToggle'>
              <div 
                className='automationToggleLink' 
                onClick={() => this.setInputToAutomated(!this.state.scanningAutomatedMode)}
                style={this.state.scanningAutomatedMode ? { margin: '0' } : {}}>
                {this.state.scanningAutomatedMode ? 'Switch to manual entry' : 'Switch to automated scanning'}
              </div>
            </div>
            {this.state.scanningAutomatedMode ?
              <div className='scanCopyWrapper'>
                <div className='scanCopyTitle'>Scanning Tips</div>
                <ul className='scanTips'>
                  <li>Automated scanning only available on newer devices (eg, iPhone 14 or greater).</li>
                  <li>If propted to allow permissions for the device camera, click <strong>Allow/Yes</strong>.</li>
                  <li>Hold the tablet with one hand and position the barcode within the camera viewfinder on the screen.</li>
                  <li>Ensure that the barcode is well-lit and clearly visible to the camera.</li>
                  <li>Align the barcode within the rectangular box displayed on the screen.</li>
                  <li>The camera will automatically focus on the barcode. When a barcode has been successfully scanned, the jewelry page will automatically open.</li>
                </ul>
              </div> :
              null
            }
          </div>
        </div>
      </RhinoModal>
		</div>;
	}
}
export default JewelrySearch;

function mapStateToProps(state) {
  return {
    jewelry: state.jewelry,
  };
}

export const JewelrySearchContainer = connect(
  mapStateToProps,
  allActionCreators
)(JewelrySearch);